import { StyleSheet, Platform } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

import cardShadow from '../../../../Common/Styles/cardShadow';

export default StyleSheet.create({
  containerStyle: theme => ({
    borderRadius: 6.2,
    paddingVertical: 16,
    paddingHorizontal: 16,
    backgroundColor: theme.colors.cardBackgroundColor,
    ...cardShadow,
  }),
  usersContainerStyle: theme => ({
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomColor: theme.colors.borderColorThree,
    borderBottomWidth: 1,
    paddingBottom: 16.7,
    marginBottom: 5,
  }),
  usersTextStyle: {
    fontSize: 16.6,
    lineHeight: 22.9,
    marginLeft: 17,
  },
  priceContainerStyle: theme => ({
    borderBottomColor: theme.colors.borderColorThree,
    borderBottomWidth: 1,
    paddingBottom: 16.2,
    marginBottom: 5,
    paddingTop: 5,
  }),
  priceDetailsViewStyle: hideProgressBars => ({
    marginTop: hideProgressBars ? 10 : 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
  }),
  priceLabelStyle: {
    fontSize: 16.6,
    ...Fonts.type.bold,
    alignSelf: 'flex-start',
    ...Platform.select({
      ios: {
        top: -2,
      },
      android: {
        top: 5,
      },
    }),
  },
  priceTextStyleStyle: {
    fontSize: 32,
    fontFamily: Fonts.type.VodafoneLt,
  },
  priceIncludeVatTextStyle: theme => ({
    textAlign: 'right',
    marginTop: 5,
    fontSize: 14.6,
    color: theme.colors.textColorNine,
    fontFamily: Fonts.type.VodafoneLt,
  }),
  priceAndCurrencyContainer: {
    marginTop: 2,
  },
  btnContainerStyle: {
    paddingTop: 25,
  },
  btnContainerStyleBottom: {
    paddingBottom: 18,
    marginTop: -8,
  },
  contractDataNoBottomDividerContainerStyle: {
    borderBottomWidth: 0,
  },
  showMoreContainer: {
    justifyContent: 'center',
    marginTop: 12.5,
  },
  showMoreText: {
    fontSize: 16.7,
    textAlign: 'center',
  },
  contractDataContainerStyle: {
    marginTop: 0,
  },
  restOfContractDataContainerStyle: {
    marginBottom: 0,
  },
  cancelButtonTextStyle: {
    color: Colors.dark_grey,
  },
  dividerShowMore: theme => ({
    height: 1,
    width: '100%',
    backgroundColor: theme.colors.dividerThree,
    marginBottom: 20,
    marginTop: -10,
    paddingHorizontal: 16,
  }),
  dividerShowLess: theme => ({
    height: 1,
    width: '100%',
    backgroundColor: theme.colors.dividerThree,
    marginBottom: 25,
    marginTop: -25,
  }),
});
